/* eslint-disable unicorn/prefer-module */
import { useEffect, useState, useCallback, useMemo } from "react";
import { FaCheck } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../context/auth";
import { getEdificios } from "../../utils";
import { Loader } from "../Loader";
import "./stylesInventarioSimple.scss";

export const InventarioSimple = () => {
  const [edificios, setEdificios] = useState();
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortedColumn, setSortedColumn] = useState(null);
  const [showOnlyOperativos, setShowOnlyOperativos] = useState(false);
  const navigate = useNavigate();

  const { pais } = useAuthContext();

  const customEstadoOrder = {
    OPERATIVO: 1,
    REACTIVACIÓN: 2,
    INSTALACIÓN: 3,
    STANDBY: 4,
  };

  const logo = useMemo(
    () =>
      ({
        Chile: require("../../img/wecast-logo.png"),
        Perú: require("../../img/visiona-logo.png"),
        Uruguay: require("../../img/screenmedia-logo.png"),
        Region: require("../../img/adigital-logo.png"),
      })[pais] || require("../../img/visiona-logo.png"),
    [pais]
  );

  useEffect(() => {
    const initialize = async () => {
      const newEdificios = await getEdificios({ pais });
      const sortedByEstado = [...newEdificios].sort(
        (a, b) => customEstadoOrder[a.estado] - customEstadoOrder[b.estado]
      );
      const sortedByEstadoAndPantallas = sortedByEstado.sort((a, b) => {
        if (a.estado === b.estado) {
          return b.pantallas - a.pantallas;
        }
        return 0;
      });
      const sortedByEstadoPantallasAndEdificio = sortedByEstadoAndPantallas.sort((a, b) => {
        if (a.estado === b.estado && a.pantallas === b.pantallas) {
          return a.edificio.localeCompare(b.edificio);
        }
        return 0;
      });
      setEdificios(sortedByEstadoPantallasAndEdificio);
    };
    initialize();
  }, [pais]);

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(column);
      setSortOrder("asc");
      setSortedColumn(column);
    }
  };

  const filteredEdificios = useMemo(() => {
    if (!edificios) return [];
    let filtered = edificios;
    if (showOnlyOperativos) {
      filtered = filtered.filter((edificio) => edificio.estado === "OPERATIVO");
    }
    return filtered;
  }, [edificios, showOnlyOperativos]);

  const sortedEdificios = useMemo(() => {
    if (!filteredEdificios) return [];
    return [...filteredEdificios].sort((a, b) => {
      if (sortBy === "pantallas" || sortBy === "personas") {
        return sortOrder === "asc" ? a[sortBy] - b[sortBy] : b[sortBy] - a[sortBy];
      }
      if (sortBy === "estado") {
        return sortOrder === "asc"
          ? customEstadoOrder[a.estado] - customEstadoOrder[b.estado]
          : customEstadoOrder[b.estado] - customEstadoOrder[a.estado];
      }
      const aValue = (a[sortBy] || "").toLowerCase();
      const bValue = (b[sortBy] || "").toLowerCase();
      return sortOrder === "asc" ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
    });
  }, [filteredEdificios, sortBy, sortOrder]);

  const localString = useCallback(
    (pais) =>
      ({
        Chile: "es-CL",
        Perú: "es-PE",
        Uruguay: "es-UY",
      })[pais] || "es-UY",
    []
  );

  let a = 1;

  return (
    <div className="inventario-simple-table ">
      <div className="logo-container mb-3">
        <img src={logo} alt={`${pais} Logo`} className="logo" onClick={() => navigate("/admin")} />
      </div>
      <div className="texto">
        <label>
          <input
            className="check"
            type="checkbox"
            checked={showOnlyOperativos}
            onChange={() => setShowOnlyOperativos((prev) => !prev)}
          />{" "}
          VER ÚNICAMENTE OPERATIVOS
        </label>
        <h6 className="texto mt-2">PUEDE REORDENAR EL CONTENIDO SEGÚN SU ENCABEZADO</h6>
      </div>
      {sortedEdificios ? (
        <table className="inventario-simple-table table table-striped table-hover table-bordered mt-3 table-sm">
          <thead className="align-middle">
            <tr>
              <th rowSpan="2" className="col-3">
                #
              </th>
              <th
                className={`col-20 ${sortedColumn === "edificio" ? "sorted" : ""}`}
                onClick={() => handleSort("edificio")}
                rowSpan="2"
              >
                EDIFICIO
                {sortedColumn === "edificio" && <span>{sortOrder === "asc" ? " ▲" : " ▼"}</span>}
              </th>
              <th
                className={`col-10 ${sortedColumn === "estado" ? "sorted" : ""}`}
                onClick={() => handleSort("estado")}
                rowSpan="2"
              >
                STATUS
                {sortedColumn === "estado" && <span>{sortOrder === "asc" ? " ▲" : " ▼"}</span>}
              </th>
              <th
                className={`col-10 ${sortedColumn === "ubicacion" ? "sorted" : ""}`}
                onClick={() => handleSort("ubicacion")}
                rowSpan="2"
              >
                UBICACIÓN
                {sortedColumn === "ubicacion" && <span>{sortOrder === "asc" ? " ▲" : " ▼"}</span>}
              </th>
              <th
                className={`col-18 ${sortedColumn === "direccion" ? "sorted" : ""}`}
                onClick={() => handleSort("direccion")}
                rowSpan="2"
              >
                DIRECCIÓN
                {sortedColumn === "direccion" && <span>{sortOrder === "asc" ? " ▲" : " ▼"}</span>}
              </th>
              <th
                className={`col-10 ${sortedColumn === "programmatic" ? "sorted" : ""}`}
                onClick={() => handleSort("programmatic")}
                rowSpan="2"
              >
                PROGRAMMATIC
                {sortedColumn === "programmatic" && <span>{sortOrder === "asc" ? " ▲" : " ▼"}</span>}
              </th>
              <th
                className={`col-10 ${sortedColumn === "personas" ? "sorted" : ""}`}
                onClick={() => handleSort("personas")}
                rowSpan="2"
              >
                PERSONAS
                {sortedColumn === "personas" && <span>{sortOrder === "asc" ? " ▲" : " ▼"}</span>}
              </th>
              <th
                className={`col-10 ${sortedColumn === "pantallas" ? "sorted" : ""}`}
                onClick={() => handleSort("pantallas")}
              >
                PANTALLAS
                {sortedColumn === "pantallas" && <span>{sortOrder === "asc" ? " ▲" : " ▼"}</span>}
              </th>
            </tr>
          </thead>
          <tbody className="table-striped text-center align-middle">
            {sortedEdificios.map(
              ({ id, edificio, pantallas, ubicacion, direccion, personas, estado, programatica }) => {
                const className =
                  estado === "OPERATIVO"
                    ? "estadoOperativo"
                    : estado === "REACTIVACIÓN"
                      ? "estadoReactivacion"
                      : estado === "INSTALACIÓN"
                        ? "estadoInstalacion"
                        : estado === "STANDBY"
                          ? "estadoStandby"
                          : "";
                const statusStyle = {
                  backgroundColor:
                    estado === "OPERATIVO"
                      ? "green"
                      : estado === "REACTIVACIÓN" || estado === "INSTALACIÓN"
                        ? "blue"
                        : estado === "STANDBY"
                          ? "red"
                          : "",
                  color: "white",
                };
                return (
                  <tr key={id}>
                    <td>{a++}</td>
                    <td className="text-start">{edificio.toUpperCase()}</td>
                    <td className={`col ${className}`} style={statusStyle}>
                      {estado}
                    </td>
                    <td>{ubicacion}</td>
                    <td>{direccion}</td>
                    <td>{programatica ? <FaCheck /> : "-"}</td>
                    <td>
                      {personas.toLocaleString(localString(pais), {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      })}
                    </td>
                    <td>{pantallas}</td>
                  </tr>
                );
              }
            )}
          </tbody>
          <tfoot className="bottom">
            <tr className="table-danger text-center align-middle">
              <td colSpan="6" />
              <td className="col bottomtotals">
                {sortedEdificios
                  .map((item) => item.personas)
                  .reduce((prev, curr) => prev + curr, 0)
                  .toLocaleString(localString(pais), {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })}
              </td>
              <td className="col bottomtotals">
                {sortedEdificios.map((item) => item.pantallas).reduce((prev, curr) => prev + curr, 0)}
              </td>
            </tr>
          </tfoot>
        </table>
      ) : (
        <Loader />
      )}
    </div>
  );
};
